import styles from "./styles.module.scss";
import { Image } from "@mantine/core";

const Logo = () => {
  return (
    <Image className={styles.logo} src="/kurb-blue-400.webp" alt="KURB" width={400} height={106} />
  );
};

export default Logo;
